import React, { useEffect, useState } from "react";
import AddDocuments from "./AddDocuments";
import ToastHOC from "../../screens/HOC/ToastHOC";
import ApiCalling from "../../network/ApiCalling";
import { Files } from "../../screens/CommonImage";
import Search from "../../assets/Icon/Search.svg";
import Util from "../../Util";

const Documents = (props) => {
  const [showForm, setShowForm] = useState(false);
  const [documents, setDocuments] = useState([]);
  const { setIsToast, setIsSubToast } = props;
  const [search, setSearch] = useState("");
  const [filteredMedia, setFilteredMedia] = useState([]);

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = () => {
    ApiCalling.apiCallParamsGet("school/school-documents")
      .then((response) => {
        // console.log("Fetched documents:", response);
        setDocuments(response.data);
        setFilteredMedia(response.data);
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
      });
  };

  const deleteDocument = (docId) => {
    ApiCalling.apiCallBodyDataPost(`school/delete-document/${docId}`)
      .then((response) => {
        console.log("Document deleted:", response);
        fetchDocuments();
        setIsToast("Success");
        setIsSubToast("Document deleted successfully.");
      })
      .catch((error) => {
        console.error("Error deleting document:", error);
        setIsToast("Error");
        setIsSubToast("Failed to delete document. Please try again.");
      });
  };

  async function handleDownload(fileUrl, fileName) {
    try {
      // Extract filename from URL
      const urlWithoutQuery = fileUrl.split("?")[0];
      const fileName = urlWithoutQuery.split("/").pop();

      // Show loading indicator (optional)
      console.log("Downloading...");

      // Fetch the file
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });

      if (!response.ok) {
        throw new Error("Download failed");
      }

      // Get the blob
      const blob = await response.blob();

      // Create blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create and trigger download
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      console.log("Download complete");
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download file. Please try again.");
    }
  }

  const getFileExtension = (attachment) => {
    if (!attachment) return "";
    try {
      const cleanUrl = attachment.split("?")[0];
      const parts = cleanUrl.split(".");
      return parts[parts.length - 1].toLowerCase();
    } catch (err) {
      return "";
    }
  };

  return (
    <>
      {/* <h2 className="page-head mt-4">Documents</h2> */}

      <div className="p-2">
        <div className="text-end mb-3">
          <button
            className={`${
              Util.hasPermission("MASTERS_ADD")
                ? "btn primary-sm-btn"
                : "no-permission"
            }`}
            onClick={() => setShowForm(!showForm)}
          >
            Add New Document
          </button>
        </div>

        {/* Documents List */}
        <div>
          {documents.length === 0 ? (
            <p className="text-muted text-center">No documents available.</p>
          ) : (
            <div className="row">
              <div className="input-group mb-4">
                <input
                  className="form-control search "
                  placeholder="Search"
                  type="text"
                  value={search}
                  onChange={(e) => {
                    // setSearch(e.target.value);
                    setSearch(e.target.value);
                    const searchValue = e.target.value;
                    if (searchValue.trim() === "") {
                      setFilteredMedia(documents);
                    } else {
                      const filtered = documents.filter((s) =>
                        s.title
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      );
                      setFilteredMedia(filtered);
                    }
                  }}
                />
                <div className="input-group-prepend">
                  <div className="search-icon">
                    <img src={Search} className="svg-icon" alt="" />
                  </div>
                </div>
              </div>
              {filteredMedia.map((doc, index) => {
                const isImage = /\.(jpg|jpeg|png|gif)(\?.*)$/i.test(
                  doc.fileName
                );
                const fileUrl = `/files/${doc.fileName}`;
                const getIconClass = (filename) => {
                  const ext = getFileExtension(filename);
                  switch (ext) {
                    case "pdf":
                      return "fa fa-file-pdf-o file-icon";
                    case "doc":
                    case "docx":
                      return "fa fa-file-word-o file-icon";
                    case "xls":
                    case "xlsx":
                      return "fa fa-file-excel-o file-icon";
                    case "mp4":
                    case "mov":
                      return "fa fa-file-video-o file-icon";
                    default:
                      return "fa fa-file file-icon";
                  }
                };

                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={index}>
                    <div className="media-container">
                      <div className="media-img-container">
                        {isImage ? (
                          <img
                            src={doc.fileName}
                            alt=""
                            className="img-fluid"
                          />
                        ) : (
                          <i
                            style={{ marginTop: "85px", fontSize: "48px" }}
                            className={getIconClass(doc.fileName)}
                          />
                        )}
                      </div>
                      <div className="row media-file-container">
                        <div className="col-10 py-2">
                          <div className="large-text wrapTwoLine text-center">
                            {doc.title}
                          </div>
                        </div>
                        <div className="col-2 text-end p-0">
                          <div
                            className="dropdown"
                            style={{ cursor: "pointer" }}
                          >
                            <i
                              className="fa fa-ellipsis-h"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              aria-hidden="true"
                            ></i>

                            <ul
                              className="dropdown-menu plus-icon-dropdown"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleDownload(doc.fileName, doc.fileName)
                                }
                              >
                                <span className="dropdown-item">Download</span>
                              </li>
                              <li style={{ cursor: "pointer" }}>
                                <a
                                  className={`${
                                    Util.hasPermission("MASTERS_DELETE")
                                      ? "dropdown-item"
                                      : "no-permission"
                                  }`}
                                  target="_blank"
                                  // href={imgDownload}
                                  onClick={() => deleteDocument(doc.id)}
                                >
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <AddDocuments
        show={showForm}
        onClose={() => {
          setShowForm(false);
        }}
        onSave={(newDoc) => {
          setShowForm(false);
          if (newDoc && newDoc === "Added") {
            setIsToast("Success");
            setIsSubToast("You have successfully added new Document");
            fetchDocuments();
          } else {
            setIsToast("Error");
            setIsSubToast("Failed to add Document. Please try again.");
          }
        }}
      />
    </>
  );
};

export default ToastHOC(Documents);
